import { AxiosRequestConfig } from "axios"
import { apis } from "service"

const BASE_URL = 'https://xxl6-bbr3-kxzs.m2.xano.io/api:'
const update_stage_tag = BASE_URL + 'FiAQK2sE/edit_stage_status'

export const update_stage = async(data:{opportunity_id:number,status:string}) => {
    const payload: AxiosRequestConfig<{opportunity_id:number,status:string}> = {
        data:{
            opportunity_id: data.opportunity_id,
            status: data.status
        }
    }

    return await apis.patch(update_stage_tag, payload)
}